import http from "../http";
import { PdfOpenenVia } from "../enums";

/** D9 (I18): hoe een pdf op een Mac opent, voor de ingelogde medewerker zelf. */
export async function zetPdfOpenenVia(waarde: PdfOpenenVia): Promise<void> {
  await http.patch("/medewerkers/mij/pdf-openen-via", { waarde });
}
